import OffreDemandeController from './offre.demande.controller';
import Template from './offre.demande.html';

export default {
    bindings: {
        offre: '=',
        isOpen: '=',
        dateDemandeCreation: '=',
        toggleDemandeDateValiditeLink: '&',
        demandeDateValiditeLinked: '<',
        toggleDemandeDateFinLink: '&',
        demandeDateFinLinked: '<',
        getTooltipDateLien: '&'
    },
    template: Template,
    controller: OffreDemandeController
};
